import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaRegCreditCard } from 'react-icons/fa6';
import Payrolls from "./index";
import ViewPayroll from "./view";
import EditPayroll from "./edit";
import ViewPayrun from "./payrunview";
import EditPayrunDtr from "./payruneditdtr";
import { MODULE_PAYROLLS } from "variables/constants";

const payrollRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Payrolls",
		basePath: "payrolls",
		mainComponent: <Payrolls />,
	    layout: "/console",	   
	    icon: <FaRegCreditCard className="icon-item" />,
	    subTitle:"Payroll",
	    viewComponent: <ViewPayroll />,
	    createComponent: <EditPayroll />,
	    editComponent: <EditPayroll />,
		level:3,
		moduleId: MODULE_PAYROLLS,
	    viewSubmodules: [{
			    name: "Payrun Details",
			    layout: "/console",
			    path: "payrolls/:payrollId/payruns/:payrunId/view",
			    component: <ViewPayrun/>,
			    isMainMenu:false,
				level:3,
				moduleId: MODULE_PAYROLLS,
		  	},
			{
			    name: "Payrun DTR Edit",
			    layout: "/console",
			    path: "payrolls/:payrollId/payruns/:payrunId/edit",
			    component: <EditPayrunDtr/>,
			    isMainMenu:false,
				level:3,
				moduleId: MODULE_PAYROLLS,
		  	}
		]
	})
]

export default payrollRoutes;